import React, { Component } from "react";
import { connect } from "react-redux";
import Typography from "@mui/material/Typography";
import withStyles from "@mui/styles/withStyles";
import { bindActionCreators } from "redux";
import { subMonths } from "date-fns";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import styles from "../../theme/globalStyles";
import actions from "../../actions";
import {
  isClinician,
  getUserVideoCallsLoading,
  getUserVideoCallsType,
  getUserVideoCallsCount,
  getUserVideoCallsSortDirection,
  getUserVideoCallsSort,
  getUserVideoCallsPerPage,
  getUserVideoCallsPage,
  getUserVideoCalls,
  getCustomerDetails,
  getSignedinState,
  isCustomerCare,
  getUserPermissionsList,
  scheduleCallSuccess,
  getUserVideoFilterStartDate,
  getUserVideoFilterEndDate,
  getVideoBreakdown,
  getVideoBreakdownLoading,
} from "../../selectors";
import { CustomTable } from "elements/DEPRECATED_elements";
import { CustomHeaderCell } from "elements/DEPRECATED_elements";
import { PageContainer, SectionContainer ,Heading,ANDatePicker} from "@answersnow/pkg-theme";
import Modal from "elements/Modal";
import Button from "@mui/material/Button";
import { capitalizeBillingTypeFirstLetter } from "../../utils/capitalizeBillingTypeFirstLetter";
import moment from "moment-timezone";
import { findDifferenceInMinutes } from "../../utils/findDifferenceInMinutes";

const mapStateToProps = (state) => ({
  signedInState: getSignedinState(state),
  customerDetails: getCustomerDetails(state),
  userVideoCalls: getUserVideoCalls(state),
  userVideoPage: getUserVideoCallsPage(state),
  userVideoRowsPerPage: getUserVideoCallsPerPage(state),
  userVideoSort: getUserVideoCallsSort(state),
  userVideoDirection: getUserVideoCallsSortDirection(state),
  userVideoCount: getUserVideoCallsCount(state),
  userVideoType: getUserVideoCallsType(state),
  userVideoCallsLoading: getUserVideoCallsLoading(state),
  isClinician: isClinician(state),
  isCustomerCare: isCustomerCare(state),
  userPermissions: getUserPermissionsList(state),
  scheduleCallSuccess: scheduleCallSuccess(state),
  userFilterStartDate: getUserVideoFilterStartDate(state),
  userFilterEndDate: getUserVideoFilterEndDate(state),
  videoCallBreakdown: getVideoBreakdown(state),
  videoCallBreakdownLoading: getVideoBreakdownLoading(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadCustomerDetails: actions.loadCustomerDetails,
      getUserVideoCalls: actions.getUserVideoCalls,
      setUserVideoCallsPage: actions.setUserVideoCallsPage,
      setUserVideoCallsPerPage: actions.setUserVideoCallsPerPage,
      setUserVideoCallsSort: actions.setUserVideoCallsSort,
      setUserVideoFilterStartDate: actions.setUserVideoFilterStartDate,
      setUserVideoFilterEndDate: actions.setUserVideoFilterEndDate,
      getVideoCallBreakdown: actions.getVideoCallBreakdown,
    },
    dispatch,
  );

class CustomerVideoCalls extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rescheduleCall: false,
      rescheduleDetails: null,
      noSessionNotesDialogOpen: false,
      downloadVideoCallId: null,
    };
  }

  componentDidMount() {
    if (this.props.match.params.clientId) {
      this.props.setUserVideoFilterStartDate(subMonths(new Date(), 1));
      this.props.setUserVideoFilterEndDate(new Date());
      this.props.getUserVideoCalls(this.props.match.params.clientId);
      this.props.loadCustomerDetails(this.props.match.params.clientId);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.userVideoPage !== this.props.userVideoPage ||
      prevProps.userVideoSort !== this.props.userVideoSort ||
      prevProps.userVideoDirection !== this.props.userVideoDirection ||
      prevProps.userVideoRowsPerPage !== this.props.userVideoRowsPerPage ||
      prevProps.userVideoType !== this.props.userVideoType ||
      prevProps.userFilterStartDate !== this.props.userFilterStartDate ||
      prevProps.userFilterEndDate !== this.props.userFilterEndDate ||
      (!prevProps.scheduleCallSuccess && this.props.scheduleCallSuccess)
    ) {
      this.props.getUserVideoCalls(this.props.match.params.clientId);
    }
    if (
      prevProps.videoCallBreakdownLoading &&
      !this.props.videoCallBreakdownLoading &&
      this.state.downloadVideoCallId
    ) {
      if (
        this.props.videoCallBreakdown.length > 0 &&
        this.props.videoCallBreakdown.some((call) => !!call.note_id)
      ) {
        this.downloadAll(this.state.downloadVideoCallId);
        this.setState({ downloadVideoCallId: null });
      } else {
        this.setState({ noSessionNotesDialogOpen: true });
      }
    }
  }

  handleChangeVideoPage = (event, page) => {
    this.props.setUserVideoCallsPage(page);
  };

  handleChangeVideoRowsPerPage = (event) => {
    this.props.setUserVideoCallsPerPage(parseInt(event.target.value));
    this.props.setUserVideoCallsPage(0);
  };

  handleVideoSortClick = (name) => {
    this.props.setUserVideoCallsSort({
      sort: name,
    });
  };

  viewVideoCallDetails = (id) => {
    let videoCall = "/video-calls/" + id;
    this.props.history.push(videoCall);
  };

  downloadAll = async (videoCallId) => {
    const baseUrl = process.env.BASE_URL;
    location.href = `${baseUrl}/download/all-session-notes/${videoCallId}`;
    this.setState({ downloadVideoCallId: null });
  };

  onClickDownloadSessionNotes = (videoCallId) => {
    this.setState({ downloadVideoCallId: videoCallId });
    this.props.getVideoCallBreakdown(videoCallId);
  };

  onCloseNoSessionNotesDialog = () => {
    this.setState({ noSessionNotesDialogOpen: false });
  };

  render() {
    const {
      classes,
      userVideoCalls,
      userVideoPage,
      userVideoCount,
      userVideoRowsPerPage,
      userVideoDirection,
      userVideoSort,
      customerDetails,
      userPermissions,
      userVideoCallsLoading,
      setUserVideoFilterEndDate,
      setUserVideoFilterStartDate,
      userFilterStartDate,
      userFilterEndDate,
    } = this.props;

    let rows = userVideoCalls;

    return (
      <PageContainer loading={userVideoCallsLoading}>
        <SectionContainer columnDirection>
          <div className={classes.headerColumnDirection}>
            <Heading>
              Video Calls
              {customerDetails.details && customerDetails.details.first_name
                ? ` - ${customerDetails.details.first_name} ${customerDetails.details.last_name}`
                : ""}
            </Heading>
            <Typography component="h5" style={{ fontSize: 15, color: "#DC2626" }}>
              * The times shown are local to the client
            </Typography>
          </div>
          <div className={classes.header}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <Typography component="p" style={{ fontSize: 20, fontWeight: 500, marginBottom: 20 }}>
                Filter By Date
              </Typography>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <ANDatePicker
                  value={userFilterStartDate ? new Date(userFilterStartDate) : null}
                  onChange={(date) => setUserVideoFilterStartDate(date)}
                  label="Start date"
                  format="PP" //"MMM d, yyyy"
                  style={{ marginRight: 20 }}
                />
                <ANDatePicker
                  value={userFilterEndDate ? new Date(userFilterEndDate) : null}
                  onChange={(date) => setUserVideoFilterEndDate(date)}
                  label="End date"
                  format="PP" //"MMM d, yyyy"
                  maxDate={new Date()}
                />
              </div>
            </div>
          </div>
          <CustomTable
            count={userVideoCount}
            rowsPerPage={userVideoRowsPerPage}
            page={userVideoPage}
            handleChangePage={this.handleChangeVideoPage}
            handleChangeRowsPerPage={this.handleChangeVideoRowsPerPage}
            noResultsMessage="No Calls Found"
            headerCells={[
              <CustomHeaderCell
                key="begin"
                label="Begin"
                sortable={true}
                sortDirection={
                  userVideoSort === "vc.scheduled_date" || !userVideoSort
                    ? userVideoDirection
                    : false
                }
                active={userVideoSort === "vc.scheduled_date"}
                onClick={() => this.handleVideoSortClick("vc.scheduled_date")}
              />,

              <CustomHeaderCell
                key="end"
                label="End"
                sortable={true}
                sortDirection={userVideoSort === "vc.start_date" ? userVideoDirection : false}
                active={userVideoSort === "vc.start_date"}
                onClick={() => this.handleVideoSortClick("vc.start_date")}
              />,
              <CustomHeaderCell key="call-duration" label="Call duration" />,
              <CustomHeaderCell key="call-type" label="Call type" />,
              <CustomHeaderCell key="call-details" label="Call details" />,
              userPermissions?.download_session_notes && (
                <CustomHeaderCell key="notes" label="Notes" align="center" />
              ),
            ]}
          >
            {rows.map((row, i) => (
              <TableRow key={row.id} style={i % 2 === 0 ? { backgroundColor: "#ECFAFA" } : null}>
                <TableCell align="left">
                  {row.start_date
                    ? moment.tz(row?.start_date, row?.call_timezone).format("MMM D, YYYY  h:mm a z")
                    : ""}
                </TableCell>
                <TableCell align="left">
                  {row.end_date
                    ? moment.tz(row?.end_date, row?.call_timezone).format("MMM D, YYYY  h:mm a z")
                    : ""}
                </TableCell>
                <TableCell align="left">
                  {row.end_date
                    ? `${findDifferenceInMinutes(row.end_date, row.start_date)} mins`
                    : ""}
                </TableCell>

                <TableCell align="left">
                  {row.billing_type ? capitalizeBillingTypeFirstLetter(row.billing_type) : null}
                </TableCell>

                <TableCell align="left">
                  <Button
                    onClick={() => this.viewVideoCallDetails(row.id)}
                    variant="text"
                    style={{ fontWeight: 500 }}
                    disabled={!userPermissions?.view_video_call_details}
                  >
                    View
                  </Button>
                </TableCell>
                {userPermissions?.download_session_notes && (
                  <TableCell align="center">
                    <Button
                      variant="text"
                      onClick={() => this.onClickDownloadSessionNotes(row.id)}
                      style={{ fontWeight: 500 }}
                    >
                      Download
                    </Button>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </CustomTable>
        </SectionContainer>

        <Modal
          open={this.state.noSessionNotesDialogOpen}
          title="No Session Notes Exist"
          description={
            <>
              This session does not have any session notes associated with it.
              <br /> Please contact the clinical department for more information.
            </>
          }
          primaryActionText="Close"
          primaryActionOnClick={this.onCloseNoSessionNotesDialog}
        />
      </PageContainer>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CustomerVideoCalls));
